import React, { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import { baseUrl } from "../utils/constants";
import { Button, IconButton } from "@mui/material";
import { useAudioRecorder } from "react-audio-voice-recorder";
import axios from "axios";
import PhonelinkRingIcon from "@mui/icons-material/PhonelinkRing";

export default function PushToTalk({
  guidance_id,
  absolute = true,
  onlyHandle,
  showHandle = true,
  startAtUp,
  setStartAtUp = () => {},
  reloadUp,
  setShowInfoUp = () => {},
  showInfoUp,
}) {
  const [startedListening, setStartedListening] = useState(false);
  const [speakingUsers, setSpeakingUsers] = useState([]);
  const [spokenUsers, setSpokenUsers] = useState([]);
  const [blinker, setBlinker] = useState(0);
  const startedAt = useRef(null);
  const { startRecording: startR, recordingBlob, stopRecording: stopR } = useAudioRecorder();
  const [showInfo, setShowInfo] = useState(false);
  const [startAt, setStartAt] = useState();
  const [, reload] = useState({});
  const currentGuidance = useRef(null);

  const startListening = () => {
    console.log("Connecting to server");
    const socket = io(baseUrl.replace("/api/admin/", "")); // Replace with your backend URL
    console.log("After io", socket);
    socket.on("connect", () => {
      console.log("Connected to server");
    });
    socket.on("disconnect", () => {
      console.log("Disconnected from server");
    });
    // Listen for button press event
    socket.on("push-to-talk", (data) => {
      console.log("Push to:", data);
      if (!data.guidance) {
        data.guidance = {
          Full_Name: data.guidance_id,
          Employee_No: data.guidance_id,
        };
      }
      data.guidance.added_on = new Date().getTime();
      setSpeakingUsers((prev) => {
        return [...prev, data.guidance];
      });
      const audio = new Audio(data.audio_url);
      audio.play();
      audio.onended = () => {
        setSpeakingUsers((prev) => {
          return prev.filter((v) => v !== data.guidance);
        });
        setSpokenUsers((prev) => {
          return [...prev.filter((v) => v.Employee_No !== data.guidance.Employee_No), data.guidance];
        });
      };
      // Update your UI here
    });

    // Clean up the connection when the component unmounts
    return () => {
      socket.disconnect();
      socket.removeAllListeners();
      socket.close();
    };
  };

  useEffect(() => {
    if (speakingUsers.length > 0) {
      const interval = setInterval(() => {
        setBlinker((prev) => (prev + 1) % 2);
      }, 500);
      return () => clearInterval(interval);
    }
  }, [speakingUsers]);

  useEffect(() => {
    if (spokenUsers.length > 0) {
      const interval = setInterval(() => {
        if (spokenUsers.find((v) => new Date().getTime() - v.added_on > 1000 * 60 * 5)) {
          setSpokenUsers((prev) => {
            return prev.filter((v) => new Date().getTime() - v.added_on < 1000 * 60 * 5);
          });
        }
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [spokenUsers]);

  const upload = async (blob, guidance_id) => {
    try {
      const formData = new FormData();
      formData.append("audio", blob, "audio.webm");
      const resp = await axios.post(baseUrl + "pushToTalkUpload/" + guidance_id, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log(resp.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    console.log(recordingBlob, currentGuidance.current);
    if (recordingBlob && currentGuidance.current) {
      upload(recordingBlob, currentGuidance.current);
    }
  }, [recordingBlob]);
  useEffect(() => {
    if (startAt) {
      console.log("Start At", startAt);
      const interval = setInterval(() => {
        console.log(new Date().getTime() - startAt);
        if (new Date().getTime() - startAt >= 2000) {
          setStartAt(undefined);
          setStartAtUp(undefined);
          startR();
          clearInterval(interval);
        }
        reload({});
        reloadUp({});
      }, 300);
      return () => clearInterval(interval);
    }
  }, [startAt, startR, setStartAtUp, reloadUp]);

  const startRecording = () => {
    if (startedAt.current || startedAt.current === 0) {
      alert("Please wait before recoding again");
      return;
    }
    startedAt.current = new Date().getTime();
    setStartAt(new Date().getTime());
    setStartAtUp(new Date().getTime());
    // console.log("Started Recording");
  };

  const stopRecording = async (guidance_id) => {
    if (startAt) {
      setStartAt(undefined);
      setStartAtUp(null);
      currentGuidance.current = null;
      startedAt.current = undefined;
      if (new Date().getTime() - startAt < 300) {
        setShowInfo(true);
        setShowInfoUp(true);
      }
    } else if (startedAt.current && new Date().getTime() - startedAt.current > 300) {
      console.log("Recording Stopped");
      currentGuidance.current = guidance_id;
      startedAt.current = undefined;
      stopR();
      await new Promise((resolve) => setTimeout(resolve, 500));
    } else {
      startedAt.current = 0;
      stopR();
      await new Promise((resolve) => setTimeout(resolve, 2000));
      console.log("Recording Too Short");
      currentGuidance.current = null;
    }
  };
  if (onlyHandle) {
    return (
      <>
        {startAtUp && (
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              pointerEvents: "none",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontSize: 50,
                  marginBottom: 20,
                  color: "black",
                  backgroundColor: "#E8DABC",
                  padding: 20,
                  borderRadius: 20,
                }}
              >
                Starting Recording in {Math.round(2 - (new Date().getTime() - startAtUp) / 1000)}
              </div>
            </div>
          </div>
        )}

        {showInfoUp && (
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontSize: 18,
                  marginBottom: 20,
                  color: "black",
                  backgroundColor: "#E8DABC",
                  padding: 20,
                  borderRadius: 20,
                }}
              >
                {guidance_id
                  ? "Press and hold the mobile phone icon to send voice to the guidance."
                  : "Press and hold the name of the spoken guidance to send voice to the guidance."}
              </div>
              <Button variant="contained" onClick={() => setShowInfoUp(false)}>
                OK
              </Button>
            </div>
          </div>
        )}
      </>
    );
  }

  return (
    <>
      {guidance_id ? (
        <IconButton
          // onClick={startRecording}
          onMouseDown={startRecording}
          onMouseUp={() => stopRecording(guidance_id)}
        >
          <PhonelinkRingIcon style={{ color: "#757575" }} />
        </IconButton>
      ) : (
        <>
          {!startedListening && (
            <Button
              variant="contained"
              onClick={() => {
                setStartedListening(true);
                startListening();
              }}
            >
              Connect to Push to Talk
            </Button>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              paddingLeft: "20px",
            }}
          >
            {spokenUsers.length > 0 && <div>Spoken Guidance</div>}
            {spokenUsers.map((v) => (
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  marginRight: 20,
                  marginLeft: 20,
                  cursor: "pointer",
                }}
                onMouseDown={startRecording}
                onMouseUp={() => stopRecording(v.Employee_No)}
              >
                <div
                  style={{
                    height: 10,
                    width: 10,
                    borderRadius: 50,
                    backgroundColor: "green",
                    marginRight: 5,
                  }}
                />
                <div>{v.Full_Name}</div>
              </div>
            ))}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              paddingLeft: "20px",
            }}
          >
            {speakingUsers.length > 0 && <div>Speaking Guidance</div>}

            {speakingUsers.map((v) => (
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  marginRight: 20,
                  marginLeft: 20,
                }}
              >
                <div
                  style={{
                    height: 10,
                    width: 10,
                    borderRadius: 50,
                    backgroundColor: blinker === 0 ? "red" : "green",
                    marginRight: 5,
                  }}
                />
                <div>{v.Full_Name}</div>
              </div>
            ))}
          </div>
          {/* <div
            style={
              absolute
                ? {
                    position: "absolute",
                    top: 100,
                    right: 50,
                    display: "flex",
                    flexDirection: "column",
                    zIndex: 1000,
                    backgroundColor: startedListening ? "#f00" : "#E8DABC",
                    padding: 10,
                    borderRadius: 20,
                  }
                : {
                    display: "flex",
                    flexDirection: "column",
                    zIndex: 1000,
                    backgroundColor: startedListening ? "#f00" : "#E8DABC",
                    padding: 5,
                    borderRadius: 20,
                  }
            }
          ></div> */}
        </>
      )}
      {showHandle && startAt && (
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                fontSize: 50,
                marginBottom: 20,
                color: "black",
                backgroundColor: "#E8DABC",
                padding: 20,
                borderRadius: 20,
              }}
            >
              Starting Recording in {Math.round(2 - (new Date().getTime() - startAt) / 1000)}
            </div>
          </div>
        </div>
      )}
      {absolute && showInfo && (
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                fontSize: 18,
                marginBottom: 20,
                color: "black",
                backgroundColor: "#E8DABC",
                padding: 20,
                borderRadius: 20,
              }}
            >
              {guidance_id
                ? "Press and hold the mobile phone icon to send voice to the guidance."
                : "Press and hold the name of the spoken guidance to send voice to the guidance."}
            </div>
            <Button variant="contained" onClick={() => setShowInfo(false)}>
              OK
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
